import { render, staticRenderFns } from "./SynergismEternityButton.vue?vue&type=template&id=165e6483&scoped=true&"
import script from "./SynergismEternityButton.vue?vue&type=script&lang=js&"
export * from "./SynergismEternityButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165e6483",
  null
  
)

export default component.exports